import * as React from 'react';
import * as s from './NotFound.scss';
import AscendLogo from '../../AscendLogo';
import { Text } from 'wix-style-react';
var NotFound = function (_a) {
    var headerText = _a.headerText, messageText = _a.messageText;
    return (React.createElement("div", { className: s.notFound },
        React.createElement(AscendLogo, null),
        React.createElement("div", { className: s.notFoundContent },
            React.createElement(Text, { className: s.notFoundHeader, weight: "bold", size: "tiny", dataHook: "not-found-header-text" }, headerText),
            React.createElement(Text, { weight: "thin", className: s.notFoundMessage, size: "medium", dataHook: "not-found-message-text" }, messageText))));
};
export default NotFound;
//# sourceMappingURL=NotFound.js.map